export default __webpack_public_path__ + "aa27bc9f63b8ce33d52c44d29d68f4a1.svg";